module.exports = __webpack_public_path__ + "img/p3.a841c182.svg";